<template>
  <div class="main- main-really-raised- w-50- ml-auto- mr-auto-">
    <div class="container-">
      <div class="row-">
        <div class="col-12-">
          <div class="card- card-signup no-shadow">
            <div class="p-4 d-flex" v-if="loading == 0 && !sia_loading">
              <!-- <send-email :disabled="tmp_company_info_for_helpers.Email === false" :selected_search_results="[{name: tmp_company_info_for_helpers.EnglishName, email: tmp_company_info_for_helpers.Email}]" />  -->
              <!-- <ca-check :selected_search_results="[{name: tmp_company_info_for_helpers.EnglishName, email: tmp_company_info_for_helpers.Email}]" />  -->
              <div class="btn-gro-up d-flex ml-auto" style="gap: 10px">
                <pdf v-if="loading == 0" :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters"
                  :goods="services" :doc_id="0" source="main-service-cn"></pdf>
                <!-- <button @click.prevent="sendToAnalyze" :disabled="history_record_id==false" class="btn btn-sm btn-outline-secondary">
                                    <span v-if="!sia_loading">{{$t('message.analyze')}}</span>
                                    <span v-else>{{ $t('message.find_partner.services_loading') }}... {{ sia_time }}</span>
                                </button> -->
              </div>
            </div>

            <div v-if="loading > 0 || sia_loading" style="position: relative; height: auto">
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                  <b-progress :value="total_loaded" :max="services.length * 3 + 1" show-progress animated></b-progress>
                </div>
              </div>
              <div class="text-center">
                {{ timer_minutes }}:{{ timer_seconds }}
              </div>
              <div class="text-center" v-if="locale == 'ru' && total_loaded == 1">
                {{ $t("message.find_partner.services_parameter_translation") }}
              </div>
              <div v-for="(srvc, i) in services_loading">
                <div class="text-center">
                  {{ $t("message.find_partner.service_" + srvc.service) }}
                  {{ $t("message.find_partner.services_loading") }}
                </div>
                <div class="text-center" v-if="srvc.loading_step == 1">
                  {{ $t("message.find_partner.services_loading_data") }}
                </div>
                <div class="text-center" v-if="srvc.loading_step == 2">
                  {{ $t("message.find_partner.services_loading_translations") }}
                </div>
                <div class="text-center" v-if="srvc.loading_step == 3">
                  {{ $t("message.find_partner.services_rendering") }}
                </div>
              </div>
            </div>

            <div class="row p-3 mx-0 mb-3 border rounded mt-3" :class="sia_loading ? 'py-5 position-relative' : ''"
              v-if="sia && sia.complex_grade">
              <div v-if="sia_loading" class="loading"></div>
              <template v-else>
                <div class="bg-light col-3 mb-3 p-3 rounded">
                  <div class="text-sm text-muted mb-1">
                    {{ $t("message.find_partner.common_info_Grade") }}
                  </div>
                  <span class="display-4 font-weight-bold" style="white-space: nowrap !important">{{ sia.complex_grade
                    }}</span>
                  <div>
                    <small><a href="#how-is-calculated2" @click.prevent="scrollTo($event)"
                        style="text-decoration: none; border-bottom: 1px dashed">{{
              $t(
                "message.find_partner.common_info_as_calculated_grade",
              )
            }}</a></small>
                  </div>
                </div>
                <div class="col-9 mb-3">
                  <div class="text-sm text-muted mb-1">
                    {{
                $t("message.find_partner.common_info_GradeDescription")
              }}
                  </div>
                  {{ sia.description }}
                </div>
              </template>
            </div>

            <search-help-text v-if="sia && sia.complex_grade"></search-help-text>

            <enterprise-fuzzy-service-cn v-if="enterprise_fuzzy_complete && loading == 0" :data="business_fuzzy_info"
              :progress="progress_fuzzy"></enterprise-fuzzy-service-cn>
            <tmp-company-info-service-cn v-if="search_company_info_complete && loading == 0"
              :data="company_info_data"></tmp-company-info-service-cn>
            <tmp-court-info-service-cn v-if="court_search_complete && loading == 0"
              :data="court_info_data"></tmp-court-info-service-cn>
            <tmp-company-news-service-cn v-if="news_search_complete && loading == 0"
              :data="news_info_data"></tmp-company-news-service-cn>
            <tmp-risk-scan-cn v-if="risk_search_complete && loading == 0" :data="risk_info_data"></tmp-risk-scan-cn>
            <tmp-annual-report-service-cn v-if="anual_search_complete && loading == 0"
              :data="annual_info_data"></tmp-annual-report-service-cn>

            <div class="row mt-4" v-if="sia.complex_grade">
              <div class="col-12" id="how-is-calculated2">
                <hr />
                <div class="text-lg font-bolder font-weight-bolder text-bolder mb-1">
                  {{
              $t("message.find_partner.common_info_as_calculated_grade")
            }}
                </div>
                {{ sia.as_calculated_grade }}
              </div>
            </div>

            <div v-if="loading == 0 && no_result" class="mt-3 text-center pb-3 alert">
              {{ noResultsLabel() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="sm" id="sia_result" title="Результат анализа" :hide-footer="true">
      <div id="sia_progress"></div>
      <div class="sia_result_text">
        <div v-for="row in sia_result_object" class="sia-row" :id="row.key">
          <span class="title">
            {{ row.label }}
          </span>
          <span class="value" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }" :content="row.value">{{
              row.value }}</span>
          <span class="text-info text-sm" v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 280 }"
            :content="row.value"><i class="fa fa-question-circle"></i></span>
        </div>
      </div>
      <!-- <div class="sia_result_text" v-html="sia_result_text"></div> -->
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import translatableField from "../../fields/translatable-field.vue";
const GaugeChart = require("gauge-chart");
export default {
  components: { translatableField },
  props: {
    keyword_input: String,
    price: Number,
  },
  data() {
    return {
      interval: null,
      myInterval: null,
      sia_loading: false,
      sia_time: "",
      sia_time_start: 0,
      sia_timer: null,
      sia_result_text: "",
      sia_result_object: [],
      sia: {},

      user_balance: 0,

      global_kw: "",
      global_log: {},
      global_log_cn: {},
      formatted_kw: "",
      history_record_id: false,

      loading: -1,
      search_company_info_complete: false,
      court_search_complete: false,
      news_search_complete: false,
      risk_search_complete: false,
      anual_search_complete: false,
      enterprise_fuzzy_complete: false,
      current_tab: 0,
      no_result: 0,
      services_loading: [],
      total_loaded: 0,

      tmp_company_info_for_helpers: {
        EnglishName: "",
        Email: "",
      },

      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      risk_info_data: {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      },
      business_fuzzy_info: {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      },
      annual_info_data: {},
      keyWord: "",
      keyWordTranslated: "",
      keyWord886: "",
      keyWord886Translated: "",
      pdf_document: {},
      services: [],
      prices: {},
      currency: "",
      service_codes: [
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      provinceCode: "",
      provinceCodeTranslated: "",
      cityCode: "",
      cityCodeTranslated: "",
      pdf_parameters: {},
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      locale: "",
      progress_fuzzy: -1,

      reduceBalanceId: null,
      servicesHasResults: { "430": null, "930": null, "701": null, "213": null, "736": null, },
    };
  },
  mounted() {
    this.doMount();
  },

  methods: {
    hasResults(serviceCode, hasResults) {
      this.servicesHasResults[serviceCode] = hasResults;

      if (Object.values(this.servicesHasResults).find(Boolean)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", true);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
      if (Object.values(this.servicesHasResults).every((v) => v === false)) {
        let fd = new FormData();
        fd.append("id", this.reduceBalanceId);
        fd.append("hasResults", false);
        this.reduceBalanceId && axios.post(window.base + "/account/updateOperationResult", fd);
        this.reduceBalanceId = null;
        this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      }
    },
    scrollTo(event) {
      let b = document
        .querySelector("#" + event.target.href.split("#")[1])
        .getBoundingClientRect();
      document
        .querySelector("#modal-details")
        .scrollTo({ top: b.y, behavior: "smooth" });
    },
    humanizeAnalyzeAPIKey(key) {
      switch (key) {
        case "high_risk":
          return "Высокий риск";
        case "plus":
          return "Плюсы";
        case "warnings":
          return "Замечания";
      }
    },
    sendToAnalyze() {
      this.sia_loading = true;
      this.sia_time_start = new Date().getTime() / 1000;
      this.sia_timer = setInterval(() => {
        let cur_time = new Date().getTime() / 1000;
        this.sia_time = (cur_time - this.sia_time_start).toFixed(0) + "s";
      }, 1000);
      axios
        .get(
          window.base +
          "/api/SIA_search?id=" +
          this.history_record_id +
          "&search_text=" +
          this.history_record_text,
        )
        .then((response) => {
          this.sia_loading = false;
          clearInterval(this.sia_timer);
          this.sia = JSON.parse(
            response.data
              .replace('"', '"')
              .replace('""', '"')
              .replace('"{', "{")
              .replace('}"', "}"),
          );
          // this.sia = JSON.parse(response.data.replace('\"', '"').replace('""', '"'))
          this.pdf_document.sia = this.sia;
          this.sia_result_text = "";
          this.sia_result_object = [];
          Object.keys(this.sia).forEach((key) => {
            if (key !== "len_dict" && key !== "complex_grade") {
              this.sia_result_object.push({
                key,
                label: this.humanizeAnalyzeAPIKey(key),
                value: this.sia[key],
              });
              // this.sia_result_text+='<div class="sia-row"><span class="title">'+this.humanizeAnalyzeAPIKey(key)+'</span><span class="value" v-tippy="{ arrow : true, theme: "light-border", maxWidth: 180 }" content="Для продолжения мониторинга включите переключатель">'+this.sia[key]+'</span></div>'
            }
          });
          // Object.keys(this.sia).forEach(key=>{
          //     if(key!=='len_dict' && key!=='complex_grade'){
          //         this.sia_result_text+='<div>'+this.sia[key]+'</div>'
          //     }
          // })

          // this.$bvModal.show('sia_result')
          // setTimeout(()=>{
          //     let container = document.querySelector('#sia_progress')

          //     let options5 = {
          //         hasNeedle: true,
          //         needleColor: 'black',
          //         arcColors: ['#c0392b', '#e67e22', '#f1c40f', '#27ae60'],
          //         arcDelimiters: [25, 50, 75],
          //         arcPadding: 6,
          //         arcPaddingColor: 'white',
          //         arcLabels: ['50', '100', '150'],
          //         arcLabelFontSize: false,
          //         //arcOverEffect: false,
          //         // label options
          //         rangeLabel: ['0', '200'],
          //         centralLabel: this.sia.complex_grade.toFixed(0),
          //         rangeLabelFontSize: false,
          //         labelsFont: 'Roboto',
          //     }

          //     GaugeChart.gaugeChart(container, 200, options5).updateNeedle(this.sia.complex_grade/2)

          // }, 500)
        });
    },
    doMount() {
      window.is_searched = false;

      this.services = ["430", "930", "701", "213", "736"];
      this.prices = {};
      this.currency = {};

      // let fd = new FormData
      // if(isNaN(this.price))
      //     this.price = 0;
      // fd.append('amount', this.price)
      // fd.append('service_code', this.services.join(','))
      // axios.post(window.base + '/account/reduceBalance', fd)
      // this.$root.$emit('reduceBalance', {price:this.price})

      this.keyWord = this.keyword_input;

      this.global_kw = this.keyWord;

      this.searchServices();

      // this.$root.$on('load-fuzzy-new-page', ()=>{
      //     console.log('load-fuzzy-new-page');
      //     this.searchenterpriseFuzzy('new-page');
      // })
      // console.log(this.services)
    },
    loadPrices() {
      this.prices = {};
      axios
        .get(window.base + "/account/GetServicesPrice")
        .then((response) => {
          this.services.forEach((key) => {
            if (typeof response.data == "object") {
              var r = response.data.find(
                (element) => element.billing_service_code === key,
              );
              if (this.$store.state.user.is_privileged)
                this.prices[key] = r.service_price_privileged;
              else this.prices[key] = r.billing_service_price;
              this.currency = r.billing_service_cur;
            }
          });
        })
        .catch(() => {
          console.log("Error loading price list...");
        });
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
            "/library/TranslateNext?text=" +
            text +
            "&source=zh&target=" +
            locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text) {
      console.log("translateTextArray");
      console.table(text);
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextArray?source=zh&target=" +
          locale,
          text,
        );
      }
    },
    translateTextArrayOfArrays(array) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          array,
        );
      }
    },
    async formatObjects(object, list) {
      console.log("formatObjects");
      console.table(object);
      return this.translateTextArray(object).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          list[i].push(JSON.parse(res.data[i]).translation);
        }
        this.company_info_data.service_info = list;
      });
    },
    // formats table data with translations
    async formatObjectTablesCompany(object, list) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              if (
                keys[i] === "CreditCode" ||
                keys[i] === "No" ||
                keys[i] === "IndustryCode" ||
                keys[i] === "SubIndustryCode"
              )
                list.push({
                  Key: keys[i],
                  Translated: values[i],
                  Original: values[i],
                });
              else {
                try {
                  list.push({
                    Key: keys[i],
                    Translated: JSON.parse(t).translation,
                    Original: values[i],
                  });
                }
                catch (er) {
                  console.error("JSON parsing error:", er);
                  console.log('Try parse: ', t);
                }
              }


            });
          })
          .catch((e) => {
            //console.log('catch formatObjectTables', e)
            //console.log(object);
            return false;
          });
      } else return true;
    },
    async formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                if (
                  keys[j] === "CreditCode" ||
                  keys[j] === "No" ||
                  keys[j] === "IndustryCode" ||
                  keys[j] === "SubIndustryCode"
                )
                  translated[keys[j]] = values[j];
                else translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              //console.log('catch formatArrayObjectTables')
              return false;
              //console.log('error translating...')
            });
        }
      } else return true;
    },
    async formatObjectTables(object, resObject) {
      console.log("formatObjectTables");
      console.table(object);
      console.table(Object.keys(object));
      console.table(Object.values(object));
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values).then((res) => {
          res.data.forEach((t, i) => {
            if (
              keys[i] === "CreditCode" ||
              keys[i] === "No" ||
              keys[i] === "IndustryCode" ||
              keys[i] === "SubIndustryCode" ||
              keys[i] == "No" ||
              keys[i] == "Year" ||
              keys[i] == "PublishDate"
            )
              resObject[keys[i]] = values[i];
            else resObject[keys[i]] = JSON.parse(t).translation;
            //list.push({Key: keys[i], Translated: JSON.parse(t).translation, Original: values[i] })
          });
        });
      } else return true;
    },
    async formatArrayObjectTablesAnnual(object, list, object_type = "wrong") {
      if (object.length > 0) {
        list = [];
        for (const obj of object) {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          await this.translateTextArray(values).then((res) => {
            var translated = {};
            for (let j = 0; j < res.data.length; j++) {
              if (
                keys[j] === "CreditCode" ||
                keys[j] === "No" ||
                keys[j] === "IndustryCode" ||
                keys[j] === "SubIndustryCode" ||
                keys[i] == "No" ||
                keys[i] == "Year" ||
                keys[i] == "PublishDate"
              )
                translated[keys[j] + "Translated"] = values[j];
              else
                translated[keys[j] + "Translated"] = JSON.parse(
                  res.data[j],
                ).translation;
            }
            list.push(translated);
          });
        }
        console.log(object_type, object, list);
        // return await Promise.all(object.map(async (obj) => {

        // }))
        // object.forEach((obj, i) => {
        //     var keys = Object.keys(obj);
        //     var values = Object.values(obj);
        //     return this.translateTextArray(values).then(res => {
        //         var translated = {};
        //         for (let j = 0; j < res.data.length; j++) {
        //             if (keys[j] === 'CreditCode' || keys[j] === 'No' || keys[j] ==='IndustryCode' || keys[j] === 'SubIndustryCode')
        //                 translated[keys[j]] = values[j];
        //             else
        //                 translated[keys[j]] = JSON.parse(res.data[j]).translation;
        //         }
        //         list.push(translated);

        //     })
        // })
      } else return true;
    },

    formatStringValues(values, keys) {
      var locale = this.$i18n.locale;

      this.translateTextArray(values).then((res) => {
        res.data.forEach((r, i) => {
          if (locale !== "cn")
            this.risk_info_data[keys[i]] = JSON.parse(r).translation;
          else this.risk_info_data[keys[i]] = values[i];
        });
      });
    },

    async makeBulkTranslation({ objects, tables, object_tables, strings }) {
      console.warn("bulk input", objects, tables, object_tables);
      const request = [];
      const request_tmp = [];
      if (typeof objects[0] !== "undefined") {
        objects.forEach((item) => request.push(Object.values(item).map(item => {
          if (typeof item != 'object') {
            return item;
          } else {
            return "";
          }
        })));
      }
      if (typeof tables[0] !== "undefined") {
        tables.forEach((item) => {
          const values = Object.values(item).map(item => {
            if (typeof item != 'object') {
              return item;
            } else {
              return "";
            }
          });
          if (values.length > 0) request.push(values);
        });
      }
      if (typeof object_tables[0] !== "undefined") {
        object_tables.forEach((table) => {
          if (Array.isArray(table)) {
            table.forEach((object) => {
              const values = Object.values(object).map(item => {
                if (typeof item != 'object') {
                  return item;
                } else {
                  return "";
                }
              });
              if (values.length > 0) request.push(values);
            });
          }
        });
      }
      if (typeof strings[0] !== "undefined") {
        strings.forEach((object) => {
          request.push(object.stringValues);
        });
      }

      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        const objects_translated = [];
        const tables_translated = [];
        const object_tables_translated = [];

        const response = await axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          request,
        ); //.then(response=>{
        let global_counter = 0;

        const data = response.data;
        console.log(request, data);
        if (typeof objects[0] !== "undefined") {
          objects.forEach((item, index) => {
            objects_translated.push(
              response.data[global_counter].map(
                (translated) => JSON.parse(translated).translation,
              ),
            );
            global_counter++;
          });
        }
        if (typeof tables[0] !== "undefined") {
          tables.forEach((item, index) => {
            const values = Object.values(item);
            if (values.length > 0) {
              const keys = Object.keys(item);
              console.log("kekekey", keys);
              const translated_object = [];
              // keys.forEach((key, key_index)=>{
              response.data[global_counter].forEach((t, i) => {
                if (
                  keys[i] === "CreditCode" ||
                  keys[i] === "No" ||
                  keys[i] === "IndustryCode" ||
                  keys[i] === "SubIndustryCode" /*|| keys[i]=='Year'*/ ||
                  keys[i] == "PublishDate"
                ) {
                  translated_object.push({
                    Key: keys[i],
                    Translated: values[i],
                    Original: values[i],
                  });
                } else {
                  try {
                    translated_object.push({
                      Key: keys[i],
                      Translated: JSON.parse(t).translation,
                      Original: values[i],
                    });
                  }
                  catch (er) {
                    console.error("JSON parsing error:", er);
                    console.log('Try parse: ', t);
                  }

                }
              });
              // })
              global_counter++;
              tables_translated.push(translated_object);
            } else {
              tables_translated.push(item);
            }
          });
        }
        console.log("tables_translated", tables_translated);
        console.log("ot", object_tables);
        if (typeof object_tables[0] !== "undefined") {
          object_tables.forEach((object) => {
            const translated_object_table = [];
            console.log("objt", object);
            if (Array.isArray(object)) {
              object.forEach((item) => {
                const values = Object.values(item);
                console.warn(
                  "trans",
                  global_counter,
                  response.data[global_counter],
                );
                if (values.length > 0) {
                  const keys = Object.keys(item);
                  const translated_object = {};
                  keys.forEach((key, key_index) => {
                    console.log("keyj", key);
                    if (
                      typeof response.data[global_counter] !== "undefined" &&
                      Array.isArray(response.data[global_counter])
                    )
                      if (
                        typeof response.data[global_counter][key_index] !==
                        "undefined"
                      ) {
                        try {
                          translated_object[key] = JSON.parse(
                            response.data[global_counter][key_index],
                          ).translation;
                        } catch (e) {
                          console.log(e)
                        }
                      }
                  });

                  translated_object_table.push(translated_object);
                } else {
                  translated_object_table.push(item);
                }
                global_counter++;
              });
            }
            object_tables_translated.push(translated_object_table);
          });
        }
        console.log("ot_", object_tables_translated);
        const strings_translated = [];
        if (typeof strings[0] !== "undefined") {
          strings.forEach((object) => {
            const tmp_object = {};

            object.stringKeys.forEach((key, i) => {
              if (Array.isArray(response.data[global_counter]))
                tmp_object[key] = JSON.parse(
                  response.data[global_counter][i],
                ).translation;
            });
            strings_translated.push(tmp_object);
            global_counter++;
          });
        }

        console.warn(
          objects_translated.length,
          tables_translated.length,
          object_tables_translated.length,
        );
        return {
          objects: objects_translated,
          tables: tables_translated,
          object_tables: object_tables_translated,
          strings: strings_translated,
        };
        // })
      }
      return { objects, tables, object_tables, strings };
    },

    async getCompanyInfoTranslations(
      service_to_translate,
      tmp_service_info,
      tmp_response_info,
    ) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [service_info],
          tables: [areaList, industryList, revokeInfoList, parentInfoList],
          object_tables: [
            EntTagList,
            ChangeList,
            UsedNameList,
            ShareHolderList,
            EmployeeList,
            InvestList,
            BranchList,
            MoreEmailList,
          ],
        } = await this.makeBulkTranslation({
          objects: [service_to_translate],
          tables: [
            tmp_response_info.Area,
            tmp_response_info.Industry,
            tmp_response_info.RevokeInfo,
            tmp_response_info.ParentInfo,
          ],
          object_tables: [
            tmp_response_info.EntTagList,
            tmp_response_info.ChangeList,
            tmp_response_info.UsedNameList,
            tmp_response_info.ShareHolderList,
            tmp_response_info.EmployeeList,
            tmp_response_info.InvestList,
            tmp_response_info.BranchList,
            tmp_response_info.MoreEmailList,
          ],
          strings: [],
        });
        // console.log(data)
        let real_service_info = [];
        real_service_info = tmp_service_info.map((item, index) => {
          return [item[0], item[1], service_info[index]];
          // return item
        });
        // 91110105599635386M

        this.$set(this.company_info_data, "service_info", real_service_info);
        this.$set(this.company_info_data, "areaList", areaList);
        this.$set(this.company_info_data, "industryList", industryList);
        this.$set(this.company_info_data, "revokeInfoList", revokeInfoList);
        this.$set(this.company_info_data, "parentInfoList", parentInfoList);

        this.$set(this.company_info_data, "EntTagList", EntTagList);
        this.$set(this.company_info_data, "ChangeList", ChangeList);
        this.$set(this.company_info_data, "UsedNameList", UsedNameList);
        this.$set(this.company_info_data, "ShareHolderList", ShareHolderList);
        this.$set(this.company_info_data, "EmployeeList", EmployeeList);
        this.$set(this.company_info_data, "InvestList", InvestList);
        this.$set(this.company_info_data, "BranchList", BranchList);
        this.$set(this.company_info_data, "MoreEmailList", MoreEmailList);
        resolve();
      });
    },
    async getRiskScanTranslations(response, stringValues, stringKeys) {
      // this.formatStringValues(stringValues, stringKeys, this.risk_info_data)
      return new Promise(async (resolve, reject) => {
        const {
          objects: [],
          tables: [Industry, Area, RevokeInfo, ContactInfo],
          object_tables: [
            Penalty,
            Exceptions,
            ShiXinItems,
            ZhiXingItems,
            MPledge,
            Pledge,
            SpotCheck,
            CompanyTaxCreditItems,
            CompanyProducts,
            PermissionEciInfo,
            PenaltyCreditChina,
            Partners,
            Employees,
            Branches,
            ChangeRecords,
            EmergingIndusty,
            TagList,
            ARContactList,
            OriginalName,
          ],
          strings: [strings],
        } = await this.makeBulkTranslation({
          objects: [],
          tables: [
            response.data.Result.Industry,
            response.data.Result.Area,
            response.data.Result.RevokeInfo,
            response.data.Result.ContactInfo,
          ],
          object_tables: [
            response.data.Result.Penalty,
            response.data.Result.Exceptions,
            response.data.Result.ShiXinItems,
            response.data.Result.ZhiXingItems,
            response.data.Result.MPledge,
            response.data.Result.Pledge,
            response.data.Result.SpotCheck,
            response.data.Result.CompanyTaxCreditItems,
            response.data.Result.CompanyProducts,
            response.data.Result.PermissionEciInfo,
            response.data.Result.PenaltyCreditChina,
            response.data.Result.Partners,
            response.data.Result.Employees,
            response.data.Result.Branches,
            response.data.Result.ChangeRecords,
            response.data.Result.EmergingIndustyList,
            response.data.Result.TagList,
            response.data.Result.ARContactList,
            response.data.Result.OriginalName,
          ],
          strings: [{ stringValues, stringKeys }],
        });
        console.log(strings);
        Object.keys(strings).forEach((key) => {
          this.$set(this.risk_info_data, key, strings[key]);
        });
        this.$set(this.risk_info_data, "Industry", Industry);
        this.$set(this.risk_info_data, "Area", Area);
        this.$set(this.risk_info_data, "RevokeInfo", RevokeInfo);
        this.$set(this.risk_info_data, "ContactInfo", ContactInfo);
        this.$set(this.risk_info_data, "Penalty", Penalty);
        this.$set(this.risk_info_data, "Exceptions", Exceptions);
        this.$set(this.risk_info_data, "ShiXinItems", ShiXinItems);
        this.$set(this.risk_info_data, "ZhiXingItems", ZhiXingItems);
        this.$set(this.risk_info_data, "MPledge", MPledge);
        this.$set(this.risk_info_data, "Pledge", Pledge);
        this.$set(this.risk_info_data, "SpotCheck", SpotCheck);
        this.$set(
          this.risk_info_data,
          "CompanyTaxCreditItems",
          CompanyTaxCreditItems,
        );
        this.$set(this.risk_info_data, "CompanyProducts", CompanyProducts);
        this.$set(this.risk_info_data, "PermissionEciInfo", PermissionEciInfo);
        this.$set(
          this.risk_info_data,
          "PenaltyCreditChina",
          PenaltyCreditChina,
        );
        this.$set(this.risk_info_data, "Partners", Partners);
        this.$set(this.risk_info_data, "Employees", Employees);
        this.$set(this.risk_info_data, "Branches", Branches);
        this.$set(this.risk_info_data, "ChangeRecords", ChangeRecords);
        this.$set(this.risk_info_data, "EmergingIndusty", EmergingIndusty);
        this.$set(this.risk_info_data, "TagList", TagList);
        this.$set(this.risk_info_data, "ARContactList", ARContactList);
        this.$set(this.risk_info_data, "OriginalName", OriginalName);
        resolve();
      });
    },
    getAnnualTranslations(result) {
      return new Promise((resolve, reject) => {
        const result_ = [];
        result.map((res, index) => {
          this.makeBulkTranslation({
            objects: [],
            tables: [res.BasicInfoData, res.AssetsData, res.SocialInsurance],
            object_tables: [
              res.ChangeList,
              res.InvestInfoList,
              res.PartnerList,
              res.ProvideAssuranceList,
              res.StockChangeList,
              res.WebSiteList,
              res.AdministrationLicenseList,
              res.BranchList,
              res.EmployeeList,
            ],
            strings: [],
          }).then(
            ({
              objects: [],
              tables: [BasicInfoData_, AssetsData_, SocialInsurance_],
              object_tables: [
                ChangeList_,
                InvestInfoList_,
                PartnerList_,
                ProvideAssuranceList_,
                StockChangeList_,
                WebSiteList_,
                AdministrationLicenseList_,
                BranchList_,
                EmployeeList_,
              ],
            }) => {
              console.warn(PartnerList_);
              console.warn({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              result_.push({
                BasicInfoData: BasicInfoData_,
                AssetsData: AssetsData_,
                SocialInsurance: SocialInsurance_,
                ChangeList: ChangeList_,
                InvestInfoList: InvestInfoList_,
                PartnerList: PartnerList_,
                ProvideAssuranceList: ProvideAssuranceList_,
                StockChangeList: StockChangeList_,
                WebSiteList: WebSiteList_,
                AdministrationLicenseList: AdministrationLicenseList_,
                BranchList: BranchList_,
                EmployeeList: EmployeeList_,
              });
              console.warn(result_);
              if (index == result.length - 1) {
                resolve(result_);
              }
            },
          );
        });
      });
    },
    requestServices() {
     this.getBusinessReference(this.keyWord886Translated);
      // if (this.services.includes("430"))
      //   //companyinfo
      //   this.searchCompanyInfo();
      // if (this.services.includes("930"))
      //   // court
      //   this.searchCourtInfo();
      // if (this.services.includes("701"))
      //   // news
      //   this.searchNewsInfo();
      // if (this.services.includes("213"))
      //   // annual
      //   this.searchAnnualInfo();

      // if (this.services.includes("736"))
      //   // risk
      //   this.searchRiskScanInfo();
      // if (this.services.includes("886"))
      //   // enterprisefuzzy
      //   this.searchenterpriseFuzzy("1");
    },
    async searchServices() {
      this.company_info_data = {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      };

      this.annual_info_data = {};
      this.pdf_document = {};

      this.court_info_data = {
        response_info: {},
      };
      this.news_info_data = {
        response_info: {},
      };
      this.risk_info_data = {
        Industry: {},
        Area: {},
        RevokeInfo: {},
        Penalty: [],
        Exceptions: [],
        ShiXinItems: [],
        ZhiXingItems: [],
        MPledge: [],
        Pledge: [],
        SpotCheck: [],
        CompanyTaxCreditItems: [],
        CompanyProducts: [],
        PermissionEciInfo: [],
        PenaltyCreditChina: [],
        Partners: [],
        Employees: [],
        Branches: [],
        ChangeRecords: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalName: [],
        ContactInfo: {},
      };
      this.business_fuzzy_info = {
        response_info: {},
        Paging: {},
        currency: "",
        price: 0,
      };

      this.no_result = 0;
      this.services_loading = [];
      this.total_loaded = 0;

      this.loading = -1;

      this.search_company_info_complete = false;
      this.court_search_complete = false;
      this.news_search_complete = false;
      this.risk_search_complete = false;
      this.anual_search_complete = false;
      this.enterprise_fuzzy_complete = false;

      this.pdf_parameters.keyWord = this.keyWord;
      this.pdf_parameters.keyWord886 = this.keyWord886;
      this.pdf_parameters.provinceCode = this.provinceCode;
      this.pdf_parameters.cityCode = this.cityCode;

      this.total_loaded = 0;
      this.locale = this.$i18n.locale;
      this.services_loading = [];
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        if (response.data.persons) {
          this.pdf_parameters.searcher_full_name =
            response.data.persons.given_name +
            " " +
            response.data.persons.middle_name +
            " " +
            response.data.persons.last_name;
        }
      });
      console.log(this.services);
      this.services.forEach((obj) => {
        var srv = {};
        srv.service = obj;
        srv.loading_step = 0;
        this.services_loading.push(srv);
      });
      console.log(this.services_loading);

      // axios.get(window.base + '/account/balance').then(response=>{
      // this.user_balance = parseFloat(response.data)
      // if(isNaN(this.user_balance))
      // this.user_balance = 0

      //console.log('params services');
      //console.log(this.services);
      // var message = '';
      // var price = 0;
      // this.services.forEach(serv => {
      //     price += this.prices[serv];
      // })
      // if (this.services.length > 1) {
      //     var names = this.service_codes.map(obj => {
      //         if (this.services.includes(obj.value))
      //             return obj.display_text;
      //     }).join(',');
      //     message = this.$t('message.find_partner.cn_bulk_services_alert').replace('{}', names) + ' ' + price + ' ' + this.currency
      // }
      // else {
      //     var name = this.service_codes.find(obj => {
      //          return obj.value === this.services[0];
      //     })
      //     message = this.$t('message.find_partner.cn_single_service_alert').replace('{}', name.display_text) + ' ' + price + ' ' + this.currency+'. '+this.$t('message.account.you_have')+' '+this.user_balance+' '+this.currency

      // }
      // if(this.user_balance<price || this.user_balance<=0){
      //     this.$bvModal.msgBoxOk(this.$t('message.account.not_enough_funds_message'), {
      //         title: this.$t('message.confirm'),
      //         size: 'sm',
      //         buttonSize: 'sm',
      //         okVariant: 'success',
      //         headerClass: 'p-2 border-bottom-0',
      //         footerClass: 'p-2 border-top-0',
      //         centered: true
      //     })
      // }else{
      // this.$bvModal.msgBoxConfirm(message, {
      //     title: this.$t('message.confirm'),
      //     size: 'sm',
      //     buttonSize: 'sm',
      //     okVariant: 'danger',
      //     okTitle: this.$t('message.yes'),
      //     cancelTitle: this.$t('message.no'),
      //     footerClass: 'p-2',
      //     hideHeaderClose: false,
      //     centered: true
      //     }).then(value => {
      let fd = new FormData();
      if (isNaN(this.price)) this.price = 0;
      fd.append("amount", this.price);
      fd.append("service_code", this.services.join(","));
      fd.append("search_keyword", this.keyWordTranslated ? this.keyWordTranslated : this.keyWord);
      this.reduceBalanceData = (await axios.post(window.base + "/account/reduceBalance", fd)).data;
      const reduceBalanceId = this.reduceBalanceData?.id || null;
                    
      if (this.reduceBalanceData?.isAccountBalanceLow) {
        this.$bvModal.msgBoxOk(this.$t("message.message.account_balance_is_low", { balance: window.rubFormat(this.reduceBalanceData.accountBalance, this.currency) }), {
          title: this.$t("message.confirm"),
          size: "md",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: this.$t("message.ok"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        });
      }

      this.servicesHasResults = Object.fromEntries(Object.keys(this.servicesHasResults).map((key) => [key, null]));
      this.$root.$emit("reduceBalance", { price: this.price });
      // if (value) {
      this.startTimer();
      this.loading = this.services.length;
      this.total_loaded++;

      switch (this.locale) {
        case "cn":
          this.locale = "zh";
          break;
        case "en":
          this.locale = "en";
          break;
        case "ru":
          this.locale = "ru";
          break;
      }
      if (this.locale == "ru") {
        let paramArray = [];
        paramArray.push(this.keyWord);
        paramArray.push(this.keyWord886);
        paramArray.push(this.provinceCode);
        paramArray.push(this.cityCode);
        axios
          .post(
            window.base + "/library/TranslateNextArray?source=ru&target=en",
            paramArray,
          )
          .then((res) => {
            // let translatedParams = res.data.map((trn) => {
            //     if (JSON.parse(trn).translation)
            //         return JSON.parse(trn).translation;
            // })
            let translatedParams = res.data.filter((trn) => {
              if (JSON.parse(trn).translation)
                return JSON.parse(trn).translation;
            });

            console.log("checkin array", translatedParams);
            // var translationMessage = this.$t('message.find_partner.search_parameters_translation') + translatedParams.map(trn => { return JSON.parse(trn).translation }).join(',');
            // this.$bvModal.msgBoxConfirm(translationMessage, {
            //     title: this.$t('message.confirm'),
            //     size: 'sm',
            //     buttonSize: 'sm',
            //     okVariant: 'danger',
            //     okTitle: this.$t('message.yes'),
            //     cancelTitle: this.$t('message.no'),
            //     footerClass: 'p-2',
            //     hideHeaderClose: false,
            //     centered: true
            //     }).then(value => {
            //         if (value) {
            //             setTimeout(() => {
            //                 this.keyWordTranslated = JSON.parse(res.data[0]).translation
            //                 this.keyWord886Translated = JSON.parse(res.data[1]).translation
            //                 this.provinceCodeTranslated = JSON.parse(res.data[2]).translation
            //                 this.cityCodeTranslated = JSON.parse(res.data[3]).translation
            //                 this.requestServices();
            //             }, 2000)
            //         }
            //         else {
            this.keyWordTranslated = this.keyWord;
            this.keyWord886Translated = this.keyWord886;
            this.provinceCodeTranslated = this.provinceCode;
            this.cityCodeTranslated = this.cityCode;
            this.requestServices();
            //     }

            // })
          });
      } else {
        this.keyWordTranslated = this.keyWord;
        this.keyWord886Translated = this.keyWord886;
        this.provinceCodeTranslated = this.provinceCode;
        this.cityCodeTranslated = this.cityCode;
        this.requestServices();
      }

      // }
      // })
      // }
      // })
    },

    /*async*/ groupAnnualResults(results) {
      console.log("group");
      console.log(results);
      return new Promise((resolve, reject) => {
        console.log("before");
        console.table(results);

        results = results.map((result) => {
          for (let key in result) {
            let data = result[key];
            if (typeof data !== "object") {
              console.log("string", data);
              result[key] = data;
            } else {
              console.warn(key);
              if (
                key == "BasicInfoData" ||
                key == "AssetsData" ||
                key == "SocialInsurance"
              ) {
                if (Array.isArray(data)) {
                  const data_ = {};
                  console.log("not string");
                  data.forEach((item) => {
                    console.log("item", item);
                    data_[item.Key] = item.Translated;
                  });
                  result[key] = data_;
                }
              } else {
                result[key] = data;
              }
            }
          }
          return result;
        });
        console.log("after");
        console.table(results);
        /*await*/ results.forEach(
          /*async*/(result) => {
            if (
              Object.keys(this.annual_info_data).indexOf(
                result.BasicInfoData.RegNo,
              ) == -1
            ) {
              //add new company
              this.annual_info_data[result.BasicInfoData.RegNo] = {
                basic_info: result.BasicInfoData,
                results: [result],
              };
              //console.log('groupresults');
              //console.log(this.annual_info_data);
            } else {
              //add result to existing company
              this.annual_info_data[result.BasicInfoData.RegNo].results.push(
                result,
              );
              //console.log('groupresults else');
              //console.log(this.annual_info_data);
            }
          },
        );
        resolve();
      });
    },
    searchenterpriseFuzzy(mode) {
      let page = 1;
      if (mode !== "new-page") {
        this.enterprise_fuzzy_complete = false;
        this.addLoading("886");
      } else {
        this.progress_fuzzy = 1;
        page = this.business_fuzzy_info.Paging.PageIndex + 1;
      }
      //
      axios
        .get("https://attis.topwoniu.com/library/openAPIEnterpriseFuzzySearch?keyWord=" +
          this.keyWord886Translated +
          "&provinceCode=" +
          this.provinceCodeTranslated +
          "&cityCode=" +
          this.cityCodeTranslated +
          "&pageIndex=" +
          page,
        )
        .then((response) => {
          // this.logServiceRequest('886', this.keyWord886 + ' ' + this.provinceCode + ' ' + this.cityCode, response.data);
          var result = response.data.Result;
          if (mode !== "new-page") this.addLoading("886");
          else this.progress_fuzzy = 2;

          if (!result) {
            if (mode !== "new-page") {
              this.loading--;
              this.no_result++;
            } else this.progress_fuzzy = 3;

            this.logServiceRequest(
              "886",
              this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
              {},
              { Status: "900" },
            );

            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.fuzzy_search_cn')).replace('{y}', this.keyWord886 + ' ' + this.provinceCode + ' ' + this.cityCode),
            //     timeout: 5000,
            // }).show();
            return;
          }
          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp).then(
            (res) => {
              if (mode !== "new-page") {
                this.addLoading("886");
                this.business_fuzzy_info.response_info = tmp;
              } else {
                this.progress_fuzzy = 3;
                this.business_fuzzy_info.response_info.push(...tmp);
              }

              this.business_fuzzy_info.Paging = response.data.Paging;
              this.business_fuzzy_info.currency = this.currency;
              this.business_fuzzy_info.price = this.prices["886"];
              this.enterprise_fuzzy_complete = true;
              this.pdf_document.business_fuzzy_info = this.business_fuzzy_info;
              this.logServiceRequest(
                "886",
                this.keyWord886 + " " + this.provinceCode + " " + this.cityCode,
                this.business_fuzzy_info,
                response.data,
              );
              if (mode !== "new-page") this.loading--;
            },
          );
        })
        .catch(() => {
          if (mode !== "new-page") {
            this.loading--;
            this.addLoading("886");
          } else this.progress_fuzzy = 3;

          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.fuzzy_search_cn"),
              ) +
              this.keyWord886 +
              " " +
              this.provinceCode +
              " " +
              this.cityCode,
            timeout: 5000,
          }).show();
        });
    },

    getBusinessReference() {
      this.addLoading("213");
      this.no_result = 0;
      this.anual_search_complete = false;
      this.search_company_info_complete = false;
      this.court_search_complete = false;
      this.news_search_complete = false;
      this.risk_search_complete = false;

      this.total_loaded = 1;

      if (this.myInterval) {
        clearInterval(this.myInterval);
      }

      this.myInterval = setInterval(() => {
        if (this.services.length * 3 + 1 > this.total_loaded + 1) {
        this.total_loaded++;
        }
      }, 10000);

      axios
        .get(`${window.base}/library/GetBusinessReference?searchText=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}&serviceCodesForLog=213,430,701,736,930&operationHistoryId=${this.reduceBalanceData?.id || 0}`)
        .then((response) => {
        if (!response.data) {
          this.no_result++;
          this.loading = 0;
          clearInterval(this.myInterval);
          this.total_loaded = 1;
          this.sia = null;
          clearInterval(this.interval);
        } else {
          console.log("GetBusinessReference", response);

          this.annual_info_data = response.data['213'].result;
          this.pdf_document.annual_info_data = this.annual_info_data;

          this.risk_info_data = response.data['736'].result;
          this.pdf_document.risk_info_data = this.risk_info_data;

          this.news_info_data = response.data['701'].result;
          this.pdf_document.news_info_data = this.news_info_data;

          this.court_info_data.response_info.VerifyResult = response.data['930'].result;
          this.pdf_document.court_info_data = this.court_info_data;

          this.company_info_data = response.data['430'].result;
          this.pdf_document.company_info_data = this.company_info_data;

          if (response.data.SIA_Response && !response.data.SIA_Response.Error) {
          this.sia = JSON.parse(response.data.SIA_Response);
          this.pdf_document.sia = this.sia;
          this.sia_loading = false;
          }

          this.search_company_info_complete = true;
          this.court_search_complete = true;
          this.news_search_complete = true;
          this.risk_search_complete = true;
          this.anual_search_complete = true;

          this.loading = 0;
          
            clearInterval(this.interval);
        }
        })
        .catch(() => {
          
          clearInterval(this.interval);
          this.no_result++;
          this.loading = 0;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.find_partner.error_loading_service").replace(
            "{}",
            this.$t("message.contragent_search.annual_report")
            ) + this.keyWord,
            timeout: 5000,
          }).show();
      });
    },

    searchAnnualInfo() {
      this.addLoading("213");
      this.anual_search_complete = false;
      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=213&keyWord=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}`)
        .then((response) => {
          this.addLoading("213");

          // this.logServiceRequest('213', this.keyWord, response.data);
          var result = response.data.Result;
          console.log("serv213", typeof response.data.Result);
          if (typeof response.data.Result !== "object") {
            this.hasResults("213", false)
            console.log("serv213conf");
            this.addLoading("213");

            this.no_result++;
            this.loading--;
            //console.log('loading annual 1')
            this.logServiceRequest("213", this.keyWord, {}, { Status: "900" });
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.contragent_search.annual_report')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("213", true)

          if (
            response.data.Result.BasicInfoData &&
            response.data.Result.BasicInfoData.CompanyName
          )
            this.tmp_company_info_for_helpers.EnglishName =
              response.data.Result.BasicInfoData.CompanyName;
          else
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;

          if (
            response.data.Result.ContactInfo &&
            response.data.Result.BasicInfoData.EmailAddress
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.BasicInfoData.EmailAddress;
          else this.tmp_company_info_for_helpers.Email = false;
          console.log("before trans");
          console.table(result);

          let result_ = result.map((item) => {
            const year = item.Year;
            const no = item.No;
            const date = item.PublishDate;

            if (typeof item.AssetsData !== "object") item.AssetsData = {};
            item.AssetsData.Year = year;
            item.AssetsData.No = no;
            item.AssetsData.PublishDate = date;
            if (typeof item.BasicInfoData !== "object") item.BasicInfoData = {};
            item.BasicInfoData.Year = year;
            item.BasicInfoData.No = no;
            item.BasicInfoData.PublishDate = date;
            if (typeof item.SocialInsurance !== "object")
              item.SocialInsurance = {};
            item.SocialInsurance.Year = year;
            item.SocialInsurance.No = no;
            item.SocialInsurance.PublishDate = date;

            item.BranchList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.EmployeeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.InvestInfoList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.ProvideAssuranceList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            item.StockChangeList = item.BranchList.map((b) => {
              b.Year = year;
              b.No = no;
              b.PublishDate = date;
              return b;
            });
            return item;
          });
          console.warn("RES", result_);
          this.getAnnualTranslations(result_).then((r) => {
            this.addLoading("213");

            //console.log('kkkk;', result.InvestInfoList)
            this.groupAnnualResults(r).then((re) => {
              this.anual_search_complete = true;
              this.loading--;
              //console.log('annual info data');
              //console.log(this.annual_info_data);
              //console.log(this.anual_search_complete)
              //console.log(this.loading);
              this.pdf_document.annual_info_data = this.annual_info_data;
              this.logServiceRequest(
                "213",
                this.keyWord,
                this.annual_info_data,
                response.data,
              );
            });
            //console.log('loading annual 2')
          });
        })
        .catch(() => {
          this.hasResults("213", false)
          this.addLoading("213");
          this.loading--;
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.annual_report"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },

    searchRiskScanInfo() {
      this.addLoading("736");
      this.risk_search_complete = false;
      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=736&keyWord=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}`)
        .then((response) => {
          // this.logServiceRequest('736', this.keyWord, response.data);
          this.addLoading("736");

          if (!response.data.Result) {
            this.hasResults("736", false)
            this.addLoading("736");
            this.loading--;
            this.no_result++;
            this.logServiceRequest("736", this.keyWord, {}, { Status: "900" });
            //console.log('risk 1')
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.contragent_search.enterprise_risk_scan')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("736", true)

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          if (
            response.data.Result.ContactInfo &&
            response.data.Result.ContactInfo.Email
          )
            this.tmp_company_info_for_helpers.Email =
              response.data.Result.ContactInfo.Email;
          else this.tmp_company_info_for_helpers.Email = false;

          var locale = this.$i18n.locale;
          var tmp = Object.entries(response.data.Result);
          tmp = tmp.filter(
            (item) => typeof item[1] !== "object" && !_.isArray(item[1]),
          );
          var stringValues = tmp.map((str) => {
            return str[1];
          });
          var stringKeys = tmp.map((str) => {
            return str[0];
          });
          this.formatStringValues(stringValues, stringKeys);
          if (locale !== "cn") {
            this.getRiskScanTranslations(
              response,
              stringValues,
              stringKeys,
            ).then((res) => {
              this.addLoading("736");
              this.risk_search_complete = true;
              this.pdf_document.risk_info_data = this.risk_info_data;
              this.logServiceRequest(
                "736",
                this.keyWord,
                this.risk_info_data,
                response.data,
              );
              this.loading--;
              //console.log('risk 2')
            });
          } else {
            this.risk_info_data = response.data.Result;
            this.risk_search_complete = true;
            this.pdf_document.risk_info_data = this.risk_info_data;
            this.loading--;
            //console.log('risk 3')
          }
        })
        .catch(() => {
          this.hasResults("736", false)
          this.loading--;
          this.addLoading("736");
          this.no_result++;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.contragent_search.enterprise_risk_scan"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchNewsInfo() {
      this.news_search_complete = false;
      this.addLoading("701");

      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=701&keyWord=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}`)
        .then((response) => {
          // this.logServiceRequest('701', this.keyWord, response.data);
          if (!response.data.Result) {
            this.hasResults("701", false)
            this.addLoading("701");

            this.logServiceRequest("701", this.keyWord, {}, { Status: "900" });

            this.no_result++;
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.corporate_news_search')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            this.loading--;
            return;
          }
          this.hasResults("701", true)
          this.tmp_company_info_for_helpers.EnglishName =
            this.keyWordTranslated;
          this.tmp_company_info_for_helpers.Email = false;

          var tmp = [];
          this.formatArrayObjectTables(response.data.Result, tmp).then(
            (res) => {
              this.addLoading("701");

              this.news_info_data.response_info = tmp;

              //console.log('news 1')

              this.news_search_complete = true;
              this.pdf_document.news_info_data = this.news_info_data;
              this.logServiceRequest(
                "701",
                this.keyWord,
                this.news_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            },
          );
        })
        .catch(() => {
          this.hasResults("701", false)
          this.loading--;
          this.no_result++;
          this.addLoading("701");

          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.corporate_news_search"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCourtInfo() {
      this.court_search_complete = false;
      this.addLoading("930");
      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=930&keyWord=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}`)
        .then((response) => {
          // this.logServiceRequest('930', this.keyWord, response.data);
          this.addLoading("930");

          if (
            response.data.Result.VerifyResult == 1 &&
            response.data.Result.Data.length > 0
          ) {
            this.hasResults("930", true)
            this.tmp_company_info_for_helpers.EnglishName =
              this.keyWordTranslated;
            this.tmp_company_info_for_helpers.Email = false;

            response.data.Result.Data.map((item) => {
              if (item.ProsecutorList.length > 0) {
                item.ProsecutorList = item.ProsecutorList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              if (item.DefendantList.length > 0) {
                item.DefendantList = item.DefendantList.map((value) => {
                  return value.Name;
                }).join(",");
              }

              return item;
            });
            var tmp = {};
            tmp.Data = [];
            this.formatArrayObjectTables(
              response.data.Result.Data,
              tmp.Data,
            ).then((res) => {
              this.addLoading("930");

              //console.log('court 1')

              this.court_search_complete = true;
              this.court_info_data.response_info = tmp;
              this.court_info_data.response_info.VerifyResult =
                response.data.Result.VerifyResult;
              this.pdf_document.court_info_data = this.court_info_data;
              this.logServiceRequest(
                "930",
                this.keyWord,
                this.court_info_data,
                response.data,
              );
              setTimeout(() => {
                this.loading--;
              }, 5000);
            });
          } else {
            this.hasResults("930", false)
            this.addLoading("930");
            this.no_result++;
            this.logServiceRequest("930", this.keyWord, {}, { Status: "900" });
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.court_notice_info')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            this.loading--;
            return;
          }
        })
        .catch(() => {
          this.hasResults("930", false)
          this.addLoading("930");
          this.no_result++;
          this.loading--;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.court_notice_info"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    searchCompanyInfo() {
      this.addLoading("430");

      axios
        .get(`${window.base}/library/GetQccAPIData?serviceCode=430&keyWord=${this.keyWordTranslated}&signalRConnectionId=${window.signalRConnectionId}`)
        .then((response) => {
          this.addLoading("430");
          // this.logServiceRequest('430', this.keyWord, response.data);
          if (!response.data.Result) {
            this.hasResults("430", false)
            this.addLoading("430");
            this.no_result++;
            this.loading--;
            this.logServiceRequest("430", this.keyWord, {}, { Status: "900" });
            // new Noty({
            //     theme: 'light',
            //     type: 'warning',
            //     text: this.$t('message.find_partner.data_is_not_found').replace('{x}', this.$t('message.find_partner.common_info_cn')).replace('{y}', this.keyWord),
            //     timeout: 5000,
            // }).show();
            return;
          }
          this.hasResults("430", true)
          var tmp_response_info = response.data.Result;

          this.tmp_company_info_for_helpers.EnglishName =
            response.data.Result.Name;
          this.tmp_company_info_for_helpers.Email = response.data.Result.Email;

          // transform change list data
          if (tmp_response_info.ChangeList.length > 0) {
            tmp_response_info.ChangeList.forEach((chg) => {
              if (typeof chg.BeforeList !== "string")
                chg.BeforeList = chg.BeforeList.join(",");
              if (typeof chg.AfterList !== "string")
                chg.AfterList = chg.AfterList.join(",");
            });
          }

          var tmp_service_info = Object.entries(response.data.Result);

          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]) && item[1],
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });

          this.getCompanyInfoTranslations(
            service_to_translate,
            tmp_service_info,
            tmp_response_info,
          ).then((r) => {
            this.addLoading("430");

            this.loading--;
            console.log("company 1");

            this.search_company_info_complete = true;
            this.company_info_data.response_info = tmp_response_info;
            this.pdf_document.company_info_data = this.company_info_data;
            this.logServiceRequest(
              "430",
              this.keyWord,
              this.company_info_data,
              response.data,
            );
          });
        })
        .catch(() => {
          this.hasResults("430", false)
          this.no_result++;
          this.loading--;
          this.addLoading("430");
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.common_info_cn"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    logServiceRequest(service_code, search_text, result, result_cn) {
      var requestlog = {};
      requestlog.service_code = service_code;
      requestlog.search_text = search_text;
      requestlog.result = result;
      this.global_log[service_code] = requestlog;
      this.global_log_cn[service_code] = result_cn;
      this.global_kw = search_text;

      // axios.post(window.base + '/contract/saveContrHistory', requestlog).then(ter => {

      // })
    },
    sendLog() {
      let requestlog = {};
      requestlog.service_code = Object.keys(this.global_log).join(",");
      requestlog.search_text = this.global_kw;
      requestlog.result = JSON.stringify(this.global_log);
      let cn = {};
      cn.all_records = Object.keys(this.global_log_cn).length;
      Object.keys(this.global_log_cn).forEach((item, index) => {
        cn["service_code_" + index] = item;
        cn["search_text_" + index] = this.global_kw;
        cn["log_data_" + index] = this.global_log_cn[item];
      });
      requestlog.china_result = JSON.stringify(cn);
      axios
        .post(window.base + "/contract/saveContrHistory", requestlog)
        .then((response) => {
          this.history_record_id = response.data;
          this.sendToAnalyze();
        })
        .catch(() => {
          this.history_record_id = 11;
          this.sendToAnalyze();
        });
    },
    addLoading(service_code) {
      console.log("serv_code", service_code);
      console.log("servic", this.services_loading);
      var service = this.services_loading.find(
        (element) => parseInt(element.service) == parseInt(service_code),
      );
      console.log("serv", service);
      service.loading_step++;
      this.total_loaded++;
    },
    startTimer() {
      var sec = 0;
      this.interval = setInterval(() => {
        this.timer_seconds = this.pad(++sec % 60);
        this.timer_minutes = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    pad(val) {
      return val > 9 ? val : "0" + val;
    },
    noResultsLabel() {
      let services_array = [];
      this.services_loading.forEach((srvc) => {
        services_array.push(
          this.$t("message.find_partner.service_" + srvc.service),
        );
      });
      let keyWords = [];
      if (this.keyWord) keyWords.push(this.keyWord);
      if (this.keyWord886) keyWords.push(this.keyWord886);
      if (this.provinceCode) keyWords.push(this.provinceCode);
      if (this.cityCode) keyWords.push(this.cityCode);

      return this.$t("message.find_partner.no_results")
        .replace("[services]", services_array.join(","))
        .replace("[parameters]", keyWords.join(","));
    },
  },
  computed: {
    is_bank() {
      return window.is_bank;
    },
    showKeyWord() {
      //console.log('checking');
      //console.log(this.services.length, this.services[0])
      if (this.services.length == 1 && this.services[0] == 886) return false;
      return true;
    },
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.doMount();
      },
    },
    keyWord() {
      window.is_searched = true;
    },
    keyWord886() {
      window.is_searched = true;
    },
    loading: function (newVal, oldVal) {
      // if (oldVal > 0 && newVal <= 0) {
      //   clearInterval(this.interval);
      //   this.sendLog();
      // }
    },
  },
};
</script>
<style>
.service-icon-holder {
  min-width: 100px;
  min-height: 100px;
  max-height: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  background: rgba(0, 123, 255, 0.3);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
}

.service-icon-holder span.api-id {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.service-text-holder {
  flex-basis: 100%;
}

.service-text-holder .service-title {
  font-weight: bold;
}

.service-text-holder .service-description {
  font-size: 13px;
}

.checkbox-holder {
  width: 30px;
  height: 100px;
  display: flex;
  justify-content: center;
}

.api-price {
  font-size: 10px;
  display: block;
  position: absolute;
  bottom: -20px;
  left: 5px;
  right: 5px;
  text-align: center;
}

.view-compact .service-icon-holder {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
}
</style>
<style>
.modal-dialog.modal-sm.modal-dialog-centered .modal-body {
  font-size: 18px;
}

.modal-dialog.modal-sm.modal-dialog-centered .modal-footer .btn {
  font-size: 18px;
  padding: 10px 20px;
}

#sia_progress {
  width: 200px;
  height: 100px;
  margin: 20px auto;
  margin-bottom: 40px;
}
</style>
